import Vue from 'vue'
import Vuex from 'vuex'

// import * as getters from './getters'
import $data from '../https/data'

Vue.use(Vuex)
var LBZ_SESSION = {
  LBZ_SESSION_ACCESSTOKEN: 'lbz_accessToken',
  LBZ_SESSION_DEFAULT_ACTIVE: 'lbz_default_active',
  LBZ_SESSION_USER_TYPE: 'ldut'
}
// 应用初始状态
const state = {
  count: 10,
  accessToken: sessionStorage.getItem(LBZ_SESSION.LBZ_SESSION_ACCESSTOKEN),
  httpHost: 'http://server.songzb.com:30000',
  // httpHost: 'http://server.zang.songzb.com:30000',
  // httpHost: 'http://hbd.server.songzb.com:30000',
  // httpHost: 'http://localhost:30000',
  areaList: [],
  defaultActive: sessionStorage.getItem(LBZ_SESSION.LBZ_SESSION_DEFAULT_ACTIVE),
  userType: sessionStorage.getItem(LBZ_SESSION.LBZ_SESSION_USER_TYPE),
  spaceDataList: ''
}
// 定义所需的 mutations
const mutations = {
  setDefaultActive (state, param) {
    state.defaultActive = param
    sessionStorage.setItem(LBZ_SESSION.LBZ_SESSION_DEFAULT_ACTIVE, param)
  },
  setAccessToken (state, params) {
    state.accessToken = params
    sessionStorage.setItem('lbz_accessToken', params)
  },
  setUserType (state, param) {
    state.userType = param
    sessionStorage.setItem(LBZ_SESSION.LBZ_SESSION_USER_TYPE, param)
  }
}
const getters = {
  getSpaseData (state) {
    var resultData
    $data.spaseData(function (res) {
      if (res && res.resultStatus === true) {
        resultData = res.resultData.list
        state.spaceDataList = resultData
        console.log(new Date().getTime())
      }
    })
  }
}

// 创建 store 实例
export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/vuex/store.js